import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmojiBoxComponent } from './emoji-box.component';
import { TabsModule } from '../tabs/tabs.module';
import { SliderModule } from '../slider/slider.module';
import { EmojiComponent } from './emoji/emoji.component';
import { CSSLoaderModule } from '../css-loaders/css-loader.module';

// 
@NgModule({
  imports: [
    CommonModule,
    TabsModule,
    SliderModule,
    CSSLoaderModule,
  ],
  declarations: [
    EmojiBoxComponent,
    EmojiComponent,
  ],
  exports: [
    EmojiBoxComponent,
  ],
  providers: [
  
  ],
})

export class EmojiPickerModule { }
